import React, { useEffect, useMemo, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'utils/hooks';

import SiteHeader from 'components/shared/SiteHeader';
import Support from 'components/shared/SiteHeader/Support';
import AccountMenu from 'components/shared/SiteHeader/AccountMenu';
import CartStatus from 'components/shared/SiteHeader/CartStatus';

import sessionModule from 'domains/session';
import ui from 'domains/ui';
import activeEditor from 'domains/active_editor';
import canvases from 'domains/canvases';
import navigation from 'domains/navigation';
import cartProductCreator from 'domains/cart_product_creator';
import cartProducts from 'domains/cart_products';
import multiphotos from 'domains/multiphotos';

function WOSHeader() {
  const [showCartNotification, setShowCartNotification] = useState(false);

  const dispatch = useAppDispatch();
  const activeCanvas = useAppSelector(activeEditor.selectors.canvas);
  const cartCount = useAppSelector(cartProducts.selectors.selectTotal);
  const session = useAppSelector(sessionModule.selectors.session);

  // Cart Notification Message Dependencies
  const canvasIds = useAppSelector(canvases.selectors.selectIds);
  const multiPhotoIds = useAppSelector(multiphotos.selectors.selectIds);
  const addToCartQuantity = useAppSelector(cartProductCreator.selectors.quantity);

  // Cart Notification Dependencies
  const addToCartSuccess = useAppSelector(cartProductCreator.selectors.wasSuccessful);
  const addToCartWasEdit = useAppSelector(cartProductCreator.selectors.wasEdit);
  const hasMobileNavigation = useAppSelector(ui.selectors.hasMobileNavigation);

  function handleCartStatusClick() {
    dispatch(navigation.actions.navigateTo('cart'));

    if (activeCanvas && activeCanvas.cartProductId) {
      dispatch(canvases.actions.resetToSingleCanvas(activeCanvas.id));
    }
  }

  const cartNotificationMessage = useMemo(() => {
    const multiple = canvasIds.length > 1 || multiPhotoIds.length > 1 || addToCartQuantity > 1;
    return multiple ? 'Items were added to your cart!' : 'Item was added to your cart!';
  }, [canvasIds, multiPhotoIds, addToCartQuantity]);

  useEffect(() => {
    if (addToCartSuccess && (!addToCartWasEdit || !hasMobileNavigation)) {
      setShowCartNotification(true);
    }
  }, [addToCartSuccess, addToCartWasEdit, hasMobileNavigation]);

  return (
    <SiteHeader>
      <Support />
      <AccountMenu session={session} />
      <CartStatus
        onClick={handleCartStatusClick}
        confirmationMessage={cartNotificationMessage}
        showCartNotification={showCartNotification}
        setShowCartNotification={setShowCartNotification}
        cartCount={cartCount}
      />
    </SiteHeader>
  );
}

export default WOSHeader;
